import { useEffect } from "react";

import isEqual from "lodash/isEqual";
import { useCustomCompareEffect } from "use-custom-compare";
import useAppSearch from "../../../hooks/router/useAppSearch";
import { useAvailablePools } from "../../../hooks/useAvailablePools";
import { selectBestPoolByOutcome } from "../../../utils/pool.utils";
import { OrderActions } from "../actions";
import { useOrderContext } from "../context";

export const useActivePool = () => {
  const { state, dispatch } = useOrderContext();
  const { given, taken } = useAppSearch();
  const activeGiven = state.flowData.syncSearch ? given : state.assets?.given?.metadata?.assetId;
  const activeTaken = state.flowData.syncSearch ? taken : state.assets?.taken?.metadata?.assetId;

  const { availablePools, isLoading } = useAvailablePools({
    givenAssetId: activeGiven,
    takenAssetId: activeTaken,
  });

  const chosenPool = selectBestPoolByOutcome(
    availablePools,
    state.assets?.given,
    state.assets?.taken
  );

  useEffect(() => {
    if (!state.flowData.syncPool) {
      return;
    }

    OrderActions.setFetchingPool(isLoading, dispatch, "OrderContext.useActivePool.isLoading");
  }, [isLoading, state.flowData.syncPool]);

  useCustomCompareEffect(
    () => {
      if (
        isLoading ||
        activeGiven === undefined ||
        activeTaken === undefined ||
        !state.flowData.syncPool
      ) {
        return;
      }

      if (!chosenPool) {
        return OrderActions.unsetPool(dispatch, "OrderContext.useActivePool.noPools");
      } else {
        OrderActions.setPool(chosenPool, dispatch, "OrderContext.useActivePool.firstPool");
      }
    },
    [
      activeGiven,
      activeTaken,
      availablePools,
      chosenPool,
      dispatch,
      isLoading,
      state.flowData.syncPool,
    ],
    isEqual
  );
};
